import Pagination from './Pagination.js'
import './VideoPlayer/index.js'

function getComponent(key) {
  switch (key) {
    case 'pagination':
      return Pagination
  }
}

export default function initComponents() {
  ;[...document.querySelectorAll('[data-component]')].forEach((element) => {
    const componentKey = element.getAttribute('data-component')
    const Component = getComponent(componentKey)

    if (Component) {
      new Component(element)
    }
  })

  // account for legacy video player code
  document.querySelectorAll('.video-component').forEach((element) => {
    const videoElement = document.createElement('video-player')

    videoElement.setAttribute(
      'data-settings',
      element.getAttribute('data-settings')
    )

    element.appendChild(videoElement)
  })
}
